import { useContext, useEffect } from 'react';
import { useTranslations } from '@altermaind/core/i18n';
import { Box } from '@altermaind/web/ui';
import { GoBack, ClaimsComponent } from '@/_shared/components';
import { LayoutContext } from '@/_shared/components/PageLayout';
import { Roles } from '@/_shared/constants';
import { Sections } from '../components';

export const MyContentsScreen = () => {
  const t = useTranslations('trainingHardSkills');
  const { setLayout } = useContext(LayoutContext);

  useEffect(() => {
    setLayout({ title: 'trainingHardSkills' });
  }, [setLayout, t]);

  return (
    <>
      <GoBack />
      <ClaimsComponent roles={[Roles.Employee, Roles.Manager]}>
        <>
          <Box mb='l'>
            <Sections.ContentsInProgress />
          </Box>
          <Sections.PaginatedContents myContents />
        </>
      </ClaimsComponent>
    </>
  );
};
